import {createRouter,createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/*',
    redirect: '/wechart'
  },
  {
    name: '/user',
    component: () => import('./view/user'),
    meta: {
      title: '微信认证'
    }
  },
  {
    name: '/orderUser',
    component: () => import('./view/orderUser'),
    meta: {
      title: '微信认证'
    }
  },
  {
    path: '/wechart',
    component: () => import('./view/wechart'),
    meta: {
      title: '绑定用户信息'
    }
  },
  {
    path: '/order',
    component: () => import('./view/order'),
    meta: {
      title: '订单信息'
    }
  },
  {
    path: '/hellWorld',
    component: () => import('./components/HelloWorld.vue'),
    meta: {
      title: 'hellWorld'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

// const router = new Router({ routes });



// router.beforeEach((to, from, next) => {
//   const title = to.meta && to.meta.title;
//   if (title) {
//     document.title = title;
//   }
//   next();
// });

export default createRouter({
  history: createWebHistory(),
  routes
})
